import React, {useMemo, useState} from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import moment from 'moment';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';
import {PurchaseStatus, PurchaseStatusOptions} from "@models/purchase";
import {PaymentGatewayOptions} from "../../models/paymentGateway";
import PackagesSelection from "@components/packages/Selection";
import ClientSelection from "@components/clients/Selection"
import {REGEX_PATTERNS} from "../../constants/regex";
import __i18n from "../../intl/__i18n";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SubscriptionsReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null);
  
  const defaultDisableRane = useMemo(() => [{
    disabled: true,
    start: moment().add(1, "d"),
    end: moment("3000/01/01")
  }], []);
  
  const disabledEndDateRange = useMemo(() => {
    return startDate ? [{
      disabled: true,
      start: moment("1970/01/01"),
      end: moment(startDate).add(-1, "d")
    }, ...defaultDisableRane] : defaultDisableRane
  }, [startDate]);
  
  const inputs = [{
    name: "client_id",
    label: <FormattedMessage id="app.client" defaultMessage={`Client`}/>,
    component: ClientSelection,
    size: 8,
    type: SearchInputType.SELECT,
    InputProps: {
      mode: SelectionMode.DEFAULT,
    }
  },{
    name: "msisdn",
    label: <FormattedMessage id="app.mobile" defaultMessage={`Mobile`}/>,
    size: 8,
    type: SearchInputType.TEXT,
    validationRules:[{
      pattern: REGEX_PATTERNS.MOBILE,
      message: __i18n("{value} is not valid.", {
        value : __i18n("Value")
      })
    }],
    InputProps: {
      placeholder: "989121111111"
    }
  }, {
    name: "package_id",
    label: <FormattedMessage id="app.package" defaultMessage={`Package`}/>,
    component: PackagesSelection,
    size: 8,
    type: SearchInputType.SELECT,
    InputProps: {
      mode: SelectionMode.DEFAULT
    }
  }, {
    name: "gateway",
    label: <FormattedMessage id="app.payment_gateway" defaultMessage={`Payment Gateway`}/>,
    type: SearchInputType.SELECT,
    options: PaymentGatewayOptions,
    selectionType: SelectionMode.DEFAULT,
    size: 8,
  }, {
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: PurchaseStatusOptions,
    selectionType: SelectionMode.DEFAULT,
    size: 8,
  }, {
    name: "start",
    label: <FormattedMessage id="app.start" defaultMessage={`Start`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps: {
      onChange: (date) => setStartDate(date),
      ranges: [{
        disabled: true,
        start: moment().add(1, "d"),
        end: endDate ? moment(endDate).add(-1, "d") : moment("3000/01/01")
      }]
    }
  }, {
    name: "end",
    label: <FormattedMessage id="app.end" defaultMessage={`End`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps: {
      onChange: (date) => setEndDate(date),
      disabled: startDate ? false : true,
      ranges: disabledEndDateRange
    }
  }];
  
  return (
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default SubscriptionsReportSearch;